import { format as UikFormat } from '@appd/uik';
import get from 'lodash/get';
import { DateTime } from 'luxon';

/**
 * This methods formats a value
 * @param type uik format data type
 * @param value value to format
 * @param options options to apply to uik format function
 * @returns
 */
export const format = (type: string, value: unknown, options?: { [k: string]: unknown }) => {
  // use luxon to format dateTime values (uik does not expose all luxon capability)
  if (type === 'dateTime' && typeof options?.preset === 'string') {
    const preset = get(DateTime, options?.preset as string) ?? DateTime.DATETIME_SHORT;
    return DateTime.fromISO(String(value)).toLocaleString(preset);
  }
  const f = get(UikFormat, type);
  if (typeof f === 'function') {
    return typeof options === undefined ? f(value) : f(value, options);
  }
  return value;
};
